import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { EMPTY } from 'rxjs';
import { catchError, exhaustMap, tap, withLatestFrom } from 'rxjs/operators';

import { StatusActions, UpgradeActions } from '../actions';
import { UpgradeFlightsService } from '../../services/upgrade-flights.service';
import { UpgradeResponse } from '../../api/models';
import { Stage } from '../../interfaces/stage.interface';
import { State } from '../../interfaces/store.interface';
import { DataActions, getMoneyPaymentNotSelected } from '../../store';
import { UpgradeError } from '../../interfaces';

@Injectable()
export class UpgradeFlightsEffects {
  upgrade$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UpgradeActions.upgradeFlights.type),
        exhaustMap(() => this.upgradeService.upgradeFlights()),
        withLatestFrom(this.store.pipe(select(getMoneyPaymentNotSelected))),
        tap(([response, moneyPaymentNotSelected]: [UpgradeResponse, boolean]) => {
          this.store.dispatch(StatusActions.clearPending());

          if (moneyPaymentNotSelected) {
            this.store.dispatch(DataActions.setUpgradeResponse({ upgradeResponse: response }));
            this.store.dispatch(StatusActions.setStage({ stage: Stage.PROCESSING }));
          } else {
            window.location.href = response.url;
          }
        }),
        catchError(() => {
          // TODO: handle specific error cases and default to generic error page
          this.store.dispatch(StatusActions.clearPending());
          this.store.dispatch(StatusActions.setError({ error: UpgradeError.paymentError }));
          this.store.dispatch(StatusActions.setStage({ stage: Stage.ERROR }));

          return EMPTY;
        })
      ),
    { dispatch: false }
  );

  constructor(
    private readonly actions$: Actions<UpgradeActions.UpgradeActionsUnion>,
    private upgradeService: UpgradeFlightsService,
    private store: Store<State>
  ) {}
}
